import { render, staticRenderFns } from "./HomepageCatalogSettings.vue?vue&type=template&id=5b415f45&"
import script from "./HomepageCatalogSettings.vue?vue&type=script&lang=js&"
export * from "./HomepageCatalogSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports